if (!customElements.get('uhp-warm-gallery')) {
  customElements.define('uhp-warm-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.track = this.querySelector('.uhp-warm-slides');
      this.slides = [...this.querySelectorAll('.uhp-warm-slide')];
      this.index = 0;
      const show = (index, instant = false) => {
        this.index = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        this.update();
      };
      this.querySelectorAll('[data-index]').forEach(button => button.addEventListener('click', () => show(Number(button.dataset.index)), options));
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => show(this.index + Number(button.dataset.direction)), options));
      this.track.addEventListener('scroll', () => {this.index = Math.round(this.track.scrollLeft / this.track.clientWidth); this.update();}, options);
      this.track.addEventListener('keydown', event => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();show(this.index + (event.key === 'ArrowRight' ? 1 : -1));}}, options);
      const selectSize = (variantId, instant) => {
        const size = {'48387968789':'150','45436786933942':'120','45436786966710':'30'}[String(variantId)];
        const offer = this.closest('product-single').querySelector('[data-warm-quantity-offer]');
        if (offer) {
          offer.hidden = size !== '150';
          const wrapper = offer.closest('.product-single__box__block');
          if (wrapper) wrapper.hidden = size !== '150';
        }
        const index = this.slides.findIndex(slide => slide.dataset.size === size);
        if (index >= 0) show(index, instant);
      };
      this.closest('product-single').querySelectorAll('variant-radios, variant-selects, variant-mixed-inputs').forEach(picker => picker.addEventListener('on:variant:change', event => {
        selectSize(event.detail.variant?.id, false);
        // Native Venue resets the query string. Keep the alternate template on reload/share.
        const url = new URL(location.href); url.searchParams.set('view','warm-preview'); history.replaceState({},'',url);
      }, options));
      this.resize = new ResizeObserver(() => show(this.index, true)); this.resize.observe(this.track);
      selectSize(this.dataset.variant, true); this.update();

      const productRoot = this.closest('product-single');
      this.buyBar = productRoot.querySelector('[data-warm-buybar]');
      const quantity = productRoot.querySelector('input[name="quantity"]');
      const nativeAdd = productRoot.querySelector('button[name="add"]');
      const variantInput = productRoot.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (this.buyBar && quantity && nativeAdd && variantInput) {
        const bar = this.buyBar;
        document.body.append(bar);
        const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'nb', {style:'currency',currency:bar.dataset.currency || 'NOK',maximumFractionDigits:0}).format(cents / 100);
        const position = () => {
          const preview = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
          const rect = preview?.getBoundingClientRect();
          const overlap = rect && rect.height < 160 && rect.height && rect.top < innerHeight ? Math.max(0,innerHeight - rect.top) : 0;
          bar.style.bottom = overlap + 'px';
        };
        const sync = () => {
          const count = Number(quantity.value);
          const active = variantInput.value === '48387968789' && Number.isInteger(count) && count >= 2;
          bar.hidden = !active;
          if (!active) {document.body.style.removeProperty('--uhp-buybar-space');return;}
          const saved = Math.min(count - 1, 2) * 6100;
          bar.querySelector('[data-bar-total]').textContent = money(count * Number(bar.dataset.price) - saved);
          bar.querySelector('[data-bar-saving]').textContent = bar.dataset.saveLabel.replace('[amount]',money(saved));
          bar.querySelector('[data-bar-add]').textContent = bar.dataset.addLabel.replace('[count]',String(count));
          bar.querySelector('[data-bar-add]').disabled = this.barBusy || nativeAdd.disabled || nativeAdd.getAttribute('aria-busy') === 'true';
          position();
          document.body.style.setProperty('--uhp-buybar-space',bar.offsetHeight + 'px');
        };
        productRoot.addEventListener('input',sync,options);
        productRoot.addEventListener('change',sync,options);
        productRoot.addEventListener('click',() => queueMicrotask(sync),options);
        window.addEventListener('resize',position,options);
        window.addEventListener('scroll',position,{...options,passive:true});
        this.barObserver = new MutationObserver(sync);
        this.barObserver.observe(nativeAdd,{attributes:true,attributeFilter:['disabled','aria-busy','class']});
        const submit = bar.querySelector('[data-bar-add]');
        submit.type = 'button';
        submit.addEventListener('click', async () => {
          if (this.barBusy || bar.hidden || !quantity.reportValidity()) return;
          this.barBusy = true; sync();
          try {
            const endpoint = new URL(nativeAdd.form.getAttribute('action'), location.origin);
            endpoint.pathname += '.js';
            const response = await fetch(endpoint, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantInput.value,quantity:Number(quantity.value)}]})});
            if (!response.ok) throw new Error('cart');
            location.assign(endpoint.pathname.replace(/\/add\.js$/, ''));
          } catch (error) {
            bar.querySelector('small').textContent = bar.dataset.error;
            this.barBusy = false; sync();
          }
        }, options);
        sync();
      }

    }
    update() {
      this.querySelector('.uhp-warm-counter').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.querySelectorAll('[data-index]').forEach(button => {if (Number(button.dataset.index) === this.index) button.setAttribute('aria-current','true'); else button.removeAttribute('aria-current');});
      this.querySelector('[data-direction="-1"]').disabled = this.index === 0;
      this.querySelector('[data-direction="1"]').disabled = this.index === this.slides.length - 1;
    }
    disconnectedCallback() {this.abort?.abort();this.resize?.disconnect();this.barObserver?.disconnect();this.buyBar?.remove();document.body.style.removeProperty("--uhp-buybar-space");}
  });
}
